export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пользователь не найден"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбрать"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрыть"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])}
}